'use strict';

import React, {Component} from 'react';
import UnreadCount from 'components/UnreadCount';

class ChatButton extends Component {
	render() {
		return (
			<div className="yith_presale_chat">
				<div
					className={`chat-button ${this.props.addClass}`}
					onClick={this.props.onClick}
				>
					<UnreadCount hasUnread={this.props.hasUnread}/>
					<svg width="27" height="27" viewBox="0 0 22 22">
						<path d="M13 22l-4-6H2c-1.11-.043-2-.935-2-2V2C0 .89.89 0 2 0h18c1.11 0 2 .892 2 2v12c0 1.067-.89 1.957-2 2h-3l-4 6zm3-8h4c-.005.3-.01-12 0-12-.01.004-18 .006-18 0 .005.006 0 12 0 12h8l3 5 3-5z" fill="#FFF" fillRule="evenodd"/>
					</svg>
				</div>
			</div>
		);
	}
}


ChatButton.displayName = 'ChatButton';
ChatButton.propTypes = {
	onClick  : React.PropTypes.func,
	addClass : React.PropTypes.string,
	hasUnread: React.PropTypes.oneOfType([
		React.PropTypes.number,
		React.PropTypes.bool
	])
};

export default ChatButton;



// WEBPACK FOOTER //
// ./src/components/ChatButton.js